import React, { useContext } from 'react';
import NextLink from 'next/link';
import Head from 'next/head';
import { useUser } from '@supabase/auth-helpers-react';
import Navbar from '../../components/navbar';
import Footer from '../../components/footer';
import Modal from "../../components/modal";
import BuyCredits from '../../components/buycredits';
import { CheckoutContext } from "../../lib/CheckoutContext";
// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
export default function PreviewPage() {
  // React.useEffect(() => {
  //   // Check to see if this is a redirect back from Checkout
  //   const query = new URLSearchParams(window.location.search);
  //   if (query.get('success')) {
      
  //   }

  //   if (query.get('canceled')) {
      
  //   }
  // }, []);
  const user = useUser()
  const { setCheckoutOpen, setUiLocation, setPaymentMode, paymentClientSecret } = useContext(CheckoutContext);

  function openSubscriptionCheckout() {    
    setUiLocation("pricing-page-subscribe");
    // setQuantity(1);
    setPaymentMode("subscription");
    setCheckoutOpen(true);
    // if (!clientSecret) {
    //   setPaymentMode("subscription");
    // }      
    // setSelectedPlan("subscription");
  }  

  function openCreditsCheckout(trigger_source) {
    setUiLocation(trigger_source);
    setPaymentMode("payment");
    if (paymentClientSecret) {
      setCheckoutOpen(true);
    }
  }    

  return (
    <>
    <Head>
      <title>Pricing | StyleSense.io</title>
      <meta
        name="description"
        content="Use free features like our popular AI Face Shape Analyzer, or unlock advanced features by purchasing credits."
        key="desc"
      />
    </Head>     
    <main className="min-h-screen max-w-full overflow-x-hidden box-border flex flex-col justify-between items-center">
      <Navbar />
      {/* <form action="/api/checkout_sessions" method="POST">
      <section>
        <button type="submit" role="link" className="btn">
          Checkout
        </button>
      </section>
      </form>   */}
      {/* <input className="input input-sm input-bordered" type="number" defaultValue="5" /> */}
      <div className="px-4 mx-auto sm:px-6 lg:px-8 max-w-7xl pt-5">
        <div className="max-w-2xl mx-auto">
          <h1 className="text-2xl text-center font-bold sm:text-5xl xl:text-4xl">
            Pricing
          </h1>
          <p className="mt-6 md:text-lg leading-7 text-black/70 dark:text-white/70 lg:leading-8 lg:text-xl">
            Get started with our free offering or unlock advanced features by
            purchasing credits ($1 USD each!). Alternatively, you can unlock unlimited credits for only $30 USD per month, and incorporate StyleSense features into your daily routine.
            No hidden fees. At StyleSense, we strive to be both upfront
            and affordable.
          </p>
          <p className="hidden md:block mt-6 md:text-lg leading-7 text-black/70 dark:text-white/70 lg:leading-8 lg:text-xl">
            We are committed to delivering cutting-edge capabilities and making
            them accessible to all. Our pricing allows you to explore the world
            of personalized beauty without breaking the bank, and ensures the
            continued availability of our highly acclaimed{" "}
            <NextLink href="/face_analyzer" className="link">
              Face Shape Classification tool
            </NextLink>{" "}
            at no charge.
          </p>
        </div>
      </div>
      <div className="max-w-7xl mx-auto sm:px-6 lg:px-8">
        <div className="grid max-w-5xl grid-cols-1 mx-auto mt-3 px-6 md:mt-12 lg:grid-cols-3 lg:gap-8">
          <div className="relative bg-white border border-gray-200 divide-y divide-gray-200 rounded-2xl sm:rounded-3xl mt-3 md:mt-14 lg:mt-0">
            <div className="px-4 py-5 bg-gray-50 sm:p-6 rounded-t-2xl sm:rounded-t-3xl">
              <div className="items-center text-center">
                <h3 className="text-lg font-semibold text-gray-900">
                  Free Plan
                </h3>
              </div>
            </div>
            <div className="px-4 py-5 sm:p-6">
              <div className="flex items-end">
                <p className="text-4xl font-semibold text-gray-900">Free</p>
              </div>
              <p className="py-1 text-sm font-normal text-gray-500 ml-1.5">
                no payment
              </p>
              <div className="mt-6">
                <NextLink
                  href="/face_analyzer"
                  role="button"
                  className="inline-flex items-center justify-center w-full px-6 py-3 text-base font-medium text-white transition-all duration-200 bg-emerald-400 border border-transparent rounded-xl hover:bg-emerald-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
                  title=""
                >
                  Try for Free
                </NextLink>
              </div>
              <p className="mt-8 text-xs font-semibold tracking-widest text-gray-500 uppercase">
              What you get:
              </p> 
              <ul className="mt-4 space-y-4 text-black">
              <li className="flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-5 h-5 mr-2 text-emerald-600 shrink-0"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg>
                <p>Unlimited access to the <NextLink href="/face_analyzer" className="link link-hover">AI Face Shape Analyzer</NextLink></p>
              </li> 
              <li className="flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-5 h-5 mr-2 text-emerald-600 shrink-0"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg>
                <p>Unlimited access to <NextLink href="/makeup-recommendations/face-contour" className="link link-hover">Face Contour Makeup Guide</NextLink> and <NextLink href="/makeup-recommendations/eyeliner">Eyeliner Guide</NextLink> tools</p>
              </li>               
              <li className="flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-5 h-5 mr-2 text-emerald-600 shrink-0"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg>
                No subscription
              </li>  
              </ul>
            </div>
          </div>
          <div className="mt-6 bg-white border border-gray-200 divide-y divide-gray-200 rounded-2xl sm:rounded-3xl lg:mt-0">
            <div className="px-4 py-5 bg-gray-50 sm:p-6 rounded-t-2xl sm:rounded-t-3xl">
              <div className="text-center items-center">
                {/* <span className="text-3xl shrink-0">🚀</span>  */}
                <h3 className="text-lg font-semibold text-gray-900">
                  Pay As You Go
                </h3>
              </div>
            </div>
            <div className="px-4 py-5 sm:p-6">
              <div className="flex items-end">
                <p className="text-4xl font-semibold text-gray-900">
                  $1 <span className="text-sm">/ per credit</span>
                </p>
              </div>
              <p className="py-1 text-sm font-normal text-gray-500 ml-1.5">
                one-time payment
              </p>
              <div className="mt-6">
                {user ? (
                  <>
                    <label
                      htmlFor="my-modal-checkout"
                      role="button"
                      className="inline-flex items-center justify-center w-full px-6 py-3 text-base font-medium text-white transition-all duration-200 bg-rainbow hover:bg-hoverrainbow border-transparent rounded-xl hover:bg-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
                      title=""
                      onClick={() => openCreditsCheckout("pricing-page-credits-input")}
                    >
                      Buy Now
                    </label>
                    {/* <CheckoutButton ui_location={""}/> */}
                    {user && <BuyCredits direct_to_credits={true} trigger_source={"pricing-page-credits-input"} />}
                  </>                  
                ) : (
                  <>
                    <label
                      htmlFor="my-modal"
                      role="button"
                      className="inline-flex items-center justify-center w-full px-6 py-3 text-base font-medium text-white transition-all duration-200 bg-rainbow hover:bg-hoverrainbow border-transparent rounded-xl hover:bg-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
                      title=""
                    >
                      Buy Now
                    </label>
                    <Modal trigger={"premium_susi"} />
                  </>
                )}
              </div>
              <p className="mt-8 text-xs font-semibold tracking-widest text-gray-500 uppercase">
                What you get:
              </p>
              <ul className="mt-4 space-y-4 text-black">
                <li className="flex items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 24 24" className="w-5 h-5 mr-2 text-amber-500 shrink-0"><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm4.24 16L12 15.45 7.77 18l1.12-4.81-3.73-3.23 4.92-.42L12 5l1.92 4.53 4.92.42-3.73 3.23L16.23 18z"/></svg>
                  <p>
                    Credits to use for{" "}
                    <NextLink
                      href="/face_analyzer/eye_shape"
                      className="link link-hover"
                    >
                      AI Eye Shape Analyzer
                    </NextLink>
                  </p>
                </li>{" "}
                <li className="flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 24 24" className="w-5 h-5 mr-2 text-amber-500 shrink-0"><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm4.24 16L12 15.45 7.77 18l1.12-4.81-3.73-3.23 4.92-.42L12 5l1.92 4.53 4.92.42-3.73 3.23L16.23 18z"/></svg>
                  <p>
                    Credits to use for{" "}
                    <NextLink
                      href="/makeup-recommendations/nose-contour"
                      className="link link-hover"
                    >
                      Nose Contour Guide tool
                    </NextLink>
                  </p>
                </li>{" "}
                <li className="flex items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 24 24" className="w-5 h-5 mr-2 text-amber-500 shrink-0"><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm4.24 16L12 15.45 7.77 18l1.12-4.81-3.73-3.23 4.92-.42L12 5l1.92 4.53 4.92.42-3.73 3.23L16.23 18z"/></svg>
                  <p>
                    Credits to use for{" "}
                    <NextLink
                      href="/makeup-recommendations/blush-placement"
                      className="link link-hover"
                    >
                      Blush Placment Guide tool
                    </NextLink>
                  </p>
                </li>{" "}                
                <li className="flex items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 24 24" className="w-5 h-5 mr-2 text-amber-500 shrink-0"><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm4.24 16L12 15.45 7.77 18l1.12-4.81-3.73-3.23 4.92-.42L12 5l1.92 4.53 4.92.42-3.73 3.23L16.23 18z"/></svg>
                  One-time payment
                </li>
              </ul>
            </div>
          </div>
          <div className="mt-6 bg-white border border-gray-200 divide-y divide-gray-200 rounded-2xl sm:rounded-3xl lg:mt-0">
            <div className="px-4 py-5 bg-gray-50 sm:p-6 rounded-t-2xl sm:rounded-t-3xl">
              <div className="text-center items-center">
                {/* <span className="text-3xl shrink-0">🚀</span>  */}
                <h3 className="text-lg font-semibold text-gray-900">
                  Subscribe
                </h3>
              </div>
            </div>
            <div className="px-4 py-5 sm:p-6">
              <div className="flex items-end">
                <p className="text-4xl font-semibold text-gray-900">
                  $30 <span className="text-sm">/ per month</span>
                </p>
              </div>
              <p className="py-1 text-sm font-normal text-gray-500 ml-1.5">
                recurring payment
              </p>
              <div className="mt-6">
                {user ? (
                  // <form action="/api/checkout_sessions" method="POST">
                  //   <section>
                  //     <button
                  //       type="submit"
                  //       role="link"
                  //       className="inline-flex items-center justify-center w-full px-6 py-3 text-base font-medium text-white transition-all duration-200 bg-rainbow border-transparent rounded-xl hover:bg-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
                  //     >
                  //       Buy Now
                  //     </button>
                  //   </section>
                  // </form>
                  <>
                    <label
                      htmlFor="my-modal-checkout"
                      role="button"
                      className="inline-flex items-center justify-center w-full px-6 py-3 text-base font-medium text-white transition-all duration-200 bg-rainbowdark hover:bg-hoverrainbowdark border-transparent rounded-xl hover:bg-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
                      title=""
                      onClick={openSubscriptionCheckout}
                    >
                      Subscribe
                    </label>
                    {/* <CheckoutButton ui_location={""}/> */}
                    <BuyCredits direct_to_checkout={true} trigger_source={"pricing-page-subscribe"} />
                  </>                  
                ) : (
                  <>
                    <label
                      htmlFor="my-modal"
                      role="button"
                      className="inline-flex items-center justify-center w-full px-6 py-3 text-base font-medium text-white transition-all duration-200 bg-rainbowdark hover:bg-hoverrainbowdark border-transparent rounded-xl hover:bg-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
                      title=""
                    >
                      Subscribe
                    </label>
                    {/* <Modal trigger={"premium_susi"} /> */}
                  </>
                )}
              </div>
              <p className="mt-8 text-xs font-semibold tracking-widest text-gray-500 uppercase">
                What you get:
              </p>
              <ul className="mt-4 space-y-4 text-black">
                <li className="flex items-center">
                  {/* <MdStars className="mr-2 text-amber-500 shrink-0"/> */}
                  <p>
                    <span className='font-bold'>Unlimited</span> Credits to use towards Advanced Features, including:{" "}
                    <ul>
                      <li>                      
                      <NextLink href="/face_analyzer/eye_shape" className="flex items-center link link-hover">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 24 24" className="w-5 h-5 mr-2 text-amber-500 shrink-0"><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm4.24 16L12 15.45 7.77 18l1.12-4.81-3.73-3.23 4.92-.42L12 5l1.92 4.53 4.92.42-3.73 3.23L16.23 18z"/></svg>                        AI Eye Shape Analyzer
                      </NextLink>                        
                      </li>
                      <li>
                      <NextLink href="/makeup-recommendations/nose-contour" className="flex items-center link link-hover">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 24 24" className="w-5 h-5 mr-2 text-amber-500 shrink-0"><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm4.24 16L12 15.45 7.77 18l1.12-4.81-3.73-3.23 4.92-.42L12 5l1.92 4.53 4.92.42-3.73 3.23L16.23 18z"/></svg>                        Nose Contour Guide tool
                      </NextLink>
                      </li>
                      <li>
                      <NextLink href="/makeup-recommendations/blush-placement" className="flex items-center link link-hover">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 24 24" className="w-5 h-5 mr-2 text-amber-500 shrink-0"><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm4.24 16L12 15.45 7.77 18l1.12-4.81-3.73-3.23 4.92-.42L12 5l1.92 4.53 4.92.42-3.73 3.23L16.23 18z"/></svg>                        Blush Placment Guide tool
                      </NextLink>
                      </li>
                    </ul>
                  </p>
                </li>{" "}
                <li className="flex items-center">
                  {/* <MdStars className="mr-2 text-amber-500 shrink-0"/> */}
                  <p>
                    Ability to Edit and Save preferences <span className='text-xs'>(coming soon)</span>{" "}
                    
                  </p>
                </li>{" "}                
                {/* <li className="flex items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 24 24" className="w-5 h-5 mr-2 text-amber-500 shrink-0"><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm4.24 16L12 15.45 7.77 18l1.12-4.81-3.73-3.23 4.92-.42L12 5l1.92 4.53 4.92.42-3.73 3.23L16.23 18z"/></svg>                  One-time payment
                </li> */}
              </ul>
            </div>
          </div>          
        </div>
      </div>
      <p className="md:hidden mt-6 md:text-lg leading-7 text-black/70 dark:text-white/70 lg:leading-8 lg:text-xl px-4 mx-auto sm:px-6 lg:px-8 max-w-7xl pt-5">
        We are committed to delivering cutting-edge capabilities and making them
        accessible to all. Our pricing allows you to explore the world of
        personalized beauty without breaking the bank, and ensures the continued
        availability of our highly acclaimed{" "}
        <NextLink href="/face_analyzer" className="link">
          Face Shape Classification tool
        </NextLink>{" "}
        at no charge.
      </p>
      <Footer />
    </main>
    </>
  );
}

{/* <style jsx>
{`
  section {
    background: #ffffff;
    display: flex;
    flex-direction: column;
    width: 400px;
    height: 112px;
    border-radius: 6px;
    justify-content: space-between;
  }
  button {
    height: 36px;
    background: #556cd6;
    border-radius: 4px;
    color: white;
    border: 0;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0px 4px 5.5px 0px rgba(0, 0, 0, 0.07);
  }
  button:hover {
    opacity: 0.8;
  }
`}
</style> */}

//arrow and "Most Popular"
{/* <div className="absolute top-0 right-0 flex items-start -mt-8"><svg viewBox="0 0 83 64" fill="currentColor" xmlns="http://www.w3.org/2000/svg" className="w-auto h-16 text-brand-600"><path d="M4.27758 62.7565C4.52847 63.5461 5.37189 63.9827 6.16141 63.7318L19.0274 59.6434C19.817 59.3925 20.2536 58.5491 20.0027 57.7595C19.7518 56.97 18.9084 56.5334 18.1189 56.7842L6.68242 60.4184L3.04824 48.982C2.79735 48.1924 1.95394 47.7558 1.16441 48.0067C0.374889 48.2576 -0.0617613 49.101 0.189127 49.8905L4.27758 62.7565ZM13.4871 47.8215L12.229 47.0047L13.4871 47.8215ZM39.0978 20.5925L38.1792 19.4067L39.0978 20.5925ZM7.03921 62.9919C8.03518 61.0681 13.1417 51.1083 14.7453 48.6383L12.229 47.0047C10.5197 49.6376 5.30689 59.8127 4.37507 61.6126L7.03921 62.9919ZM14.7453 48.6383C22.0755 37.3475 29.8244 29.6738 40.0164 21.7784L38.1792 19.4067C27.7862 27.4579 19.7827 35.3698 12.229 47.0047L14.7453 48.6383ZM40.0164 21.7784C52.6582 11.9851 67.634 7.57932 82.2576 3.44342L81.4412 0.556653C66.8756 4.67614 51.3456 9.20709 38.1792 19.4067L40.0164 21.7784Z"></path></svg> 
<span className="ml-2 -mt-2 text-sm font-semibold text-brand-600">
  Most popular
</span>
</div>  */}
